export default __webpack_public_path__ + "static/OpenSans-Italic-a38e47c39e2e3cae4fc4d27195333559.woff";